import { render, staticRenderFns } from "./crmpay.vue?vue&type=template&id=80d50742&scoped=true&"
import script from "./crmpay.vue?vue&type=script&lang=js&"
export * from "./crmpay.vue?vue&type=script&lang=js&"
import style0 from "./crmpay.vue?vue&type=style&index=0&id=80d50742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d50742",
  null
  
)

export default component.exports